import React from 'react'

function MyList() {
  return (
    <>
      <div className="flex flex-col ml-36"></div>
    </>
  )
}

export default MyList